import * as React from "react";
import { SVGProps } from "react";
export const LockIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.5 18C5.08333 18 4.72933 17.854 4.438 17.562C4.146 17.2707 4 16.9167 4 16.5V8.5C4 8.08333 4.146 7.72933 4.438 7.438C4.72933 7.146 5.08333 7 5.5 7H6V5C6 3.88867 6.389 2.94433 7.167 2.167C7.94433 1.389 8.88867 1 10 1C11.1113 1 12.0557 1.389 12.833 2.167C13.611 2.94433 14 3.88867 14 5V7H14.5C14.9167 7 15.2707 7.146 15.562 7.438C15.854 7.72933 16 8.08333 16 8.5V16.5C16 16.9167 15.854 17.2707 15.562 17.562C15.2707 17.854 14.9167 18 14.5 18H5.5ZM5.5 16.5H14.5V8.5H5.5V16.5ZM10 14C10.4167 14 10.7707 13.854 11.062 13.562C11.354 13.2707 11.5 12.9167 11.5 12.5C11.5 12.0833 11.354 11.7293 11.062 11.438C10.7707 11.146 10.4167 11 10 11C9.58333 11 9.22933 11.146 8.938 11.438C8.646 11.7293 8.5 12.0833 8.5 12.5C8.5 12.9167 8.646 13.2707 8.938 13.562C9.22933 13.854 9.58333 14 10 14ZM7.5 7H12.5V5C12.5 4.30533 12.257 3.715 11.771 3.229C11.285 2.743 10.6947 2.5 10 2.5C9.30533 2.5 8.715 2.743 8.229 3.229C7.743 3.715 7.5 4.30533 7.5 5V7Z"
            fill="currentColor"
        />
    </svg>
);
LockIcon.displayName = "LockIcon";
